import React, { useCallback, useEffect, useRef, useState } from "react";

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { Modal } from "./Modal";
import { UIButtonSmall } from "../styles/ButtonStyle";
import { GameClient } from "../gameClient";
import { TooltipInfo, TutorialId, tooltipInfo } from "./TooltipInfo";

declare var gameClient: GameClient;
interface TutorialTooltipProps {
    tutorials: TutorialId[];
    fullscreen: boolean;
    onClose?: () => void;
}

const containerStyle = css`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
`;

const controlsStyle = css`
    display:flex;
    justify-content:space-between;
    align-items:center;
`;

const textStyle = css`
    font-size: 25px;
    margin-bottom: 1vh;
    margin-top: 1vh;
    min-height: 4vh;
    padding-left: 3.5vw;
    padding-right: 3.5vw;
`;

export const TutorialTooltip = (props: TutorialTooltipProps) => {
    const [currentTooltip, setCurrentTooltip] = useState<TooltipInfo | undefined>(undefined);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      const tutorial = props.tutorials[currentIndex];
      gameClient.seenTutorials.add(tutorial);
      setCurrentTooltip(tooltipInfo[tutorial]);
    }, [currentIndex]);

    useEffect(() => {
      setCurrentTooltip(tooltipInfo[props.tutorials[currentIndex]]);
      setCurrentIndex(0);
    }, [props.tutorials]);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === props.tutorials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? props.tutorials.length - 1 : prevIndex - 1
    );
  };

  return (
    <Modal isOpen={true} onClose={props.onClose} fullScreen={props.fullscreen}>
      <div css={containerStyle}>
        <h1>{currentTooltip?.title}</h1>
        <div style={{ 
          objectFit: "contain",
          width: "640px",
          height: "360px",
          display: "flex",
          justifyContent: "center",
        }}>
          {currentTooltip?.videoLink && <video autoPlay loop style={{ objectFit: "contain", maxWidth: "640px" }} src={currentTooltip?.videoLink} />}
          {currentTooltip?.imageLink && <img style={{
            width: "auto",
            height: "100%",
            maxWidth: "640px",
            maxHeight: "360px"
          }} src={currentTooltip?.imageLink} />}
        </div>
        <div css={textStyle}>{currentTooltip?.text}</div>
      </div>
      {props.tutorials.length > 1 && <div css={controlsStyle}>
        {
          currentIndex !== 0 ?
          <UIButtonSmall onClick={goToPrev}>Previous</UIButtonSmall>
          :
          <div style={{
            width: "10vw",
            height: "5vh"
          }} />
        }
        <div style={{
            display:"flex",
        }}>
            {new Array(props.tutorials.length).fill(0).map((_, i) => {
                return (
                <div key={i} onClick={() => setCurrentIndex(i)}>
                    {i === currentIndex ? '●' : '○'}
                </div>
                );
            })}
        </div>
        {
          currentIndex !== props.tutorials.length - 1 ?
          <UIButtonSmall onClick={goToNext}>Next</UIButtonSmall>
          :
          <UIButtonSmall reverse={true} onClick={props.onClose}>Close</UIButtonSmall>
        }
      </div>}
    </Modal>
  );
};
